module.exports = __webpack_public_path__ + "static/media/dn-hero.15c6575f.png";